import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import EditPaymentButton from 'src/components/Control/Buttons/EditPaymentButton';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import CancelPaymentButton from 'src/components/Control/Buttons/CancelPaymentButton';
import RefundPaymentButton from 'src/components/Control/Buttons/RefundPaymentButton';
import DownloadPaymentButton from 'src/components/Control/Buttons/DownloadPaymentButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import ShowInvoicesForPaymentButton
  from 'src/components/Control/Buttons/ShowInvoicesForPaymentButton';

const PaymentToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );

  const getPaymentId = () => {
    if (!selections.length) return 0;
    return selections[0];
  };

  return (
    <>
      <EditPaymentButton
        disabled={!selections.length} />
      <RefundPaymentButton
        disabled={selections.length !== 1}
        paymentId={getPaymentId()} />
      <CancelPaymentButton
        disabled={!selections.length} />
      <ConfigureColumnsButton
        entity={ENTITIES.payments} />
      <UnselectAllMenubutton
        entity={ENTITIES.payments}
        disabled={!selections.length} />
      <ShowInvoicesForPaymentButton
        paymentId={selections[0]}
        disabled={selections.length !== 1} />
      <DownloadPaymentButton />
    </>
  );
};

export default PaymentToolbar;
